import { create } from 'zustand'

/**
 * Global header search. The top-bar input writes `query`; pages that support
 * search read it to filter their content. Reset on navigation by the Layout.
 */
interface SearchState {
  query: string
  setQuery: (query: string) => void
}

export const useSearchStore = create<SearchState>((set) => ({
  query: '',
  setQuery: (query) => set({ query }),
}))
